import { Injectable } from '@angular/core';
import { CupomEntity } from '@domain/dto/reserva/reserva-cupom-get.dto';
import { ReservaEntity } from '@domain/dto/reserva/reserva-post.dto';
import { ReservaUsecase } from '@domain/usecases/reserva/reserva-usecase';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReservaController {
  constructor(private usecaseService: ReservaUsecase) {}

  insert(param: ReservaEntity): Observable<ReservaEntity> {
    return this.usecaseService.insert(param);
  }

  getById(cupom: string): Observable<CupomEntity> {
    return this.usecaseService.getById(cupom);
  }

  getCustomById(field: string, value: string): Observable<any> {
    return this.usecaseService.getCustomById(field, value);
  }
}
